<template>
  <div class="login" @keyup.enter.stop="trySignIn">
    <img
      src="@/assets/images/login_logo.png"
      class="login-logo-img"
      width="315px"
      height="54px"
      alt="login-logo"
    />
    <div class="login-text">ペトレルアカウントでログイン</div>
    <div class="text-input-email">
      <base-text-box v-bind="emailBox" v-model="email" name="email" />
    </div>
    <div class="text-input-password">
      <base-text-input-password placeholder="パスワード" v-model="password" />
    </div>
    <div class="login-button">
      <base-button-medium-orange @click="trySignIn" :disabled="!canSignIn"
        >ログイン</base-button-medium-orange
      >
    </div>
    <router-link
      :to="{ name: 'password-reset-send-mail' }"
      class="forget-password"
      >パスワード再設定</router-link
    >
    <announce-popup
      v-if="errorPopup.isOpened"
      @close="closePopup"
      :buttons="errorPopup.buttons"
      :title="errorPopup.title"
      :type="errorPopup.type"
      >{{ errorPopup.message }}</announce-popup
    >
    <base-loading :wait-flg="!canSignIn" />
  </div>
</template>

<script>
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import ApiLogin from '@/components/mixins/ApiLogin'
import BaseButtonMediumOrange from '@/components/parts/atoms/BaseButtonMediumOrange'
import BaseLoading from '@/components/parts/atoms/BaseLoading'
import BaseTextBox from '@/components/parts/atoms/BaseTextBox'
import BaseTextInputPassword from '@/components/parts/atoms/BaseTextInputPassword.vue'

export default {
  name: 'Login',

  components: {
    AnnouncePopup,
    BaseButtonMediumOrange,
    BaseLoading,
    BaseTextBox,
    BaseTextInputPassword
  },

  mixins: [ApiLogin],

  data() {
    return {
      canSignIn: true,
      email: process.env.VUE_APP_DEV_EMAIL || '',
      password: process.env.VUE_APP_DEV_PASSWORD || '',
      emailBox: {
        type: 'email',
        placeholder: 'メールアドレス',
        styles: {
          width: '299px',
          height: '44px'
        }
      },
      errorPopup: {
        buttons: ['閉じる'],
        isOpened: false,
        message: '',
        title: '失敗',
        type: 'failure'
      }
    }
  },

  mounted() {
    if (this.$store.getters['auth/loginStaffId'] === 0) {
      this.signOut()
    } else {
      location.reload()
    }
  },

  methods: {
    closePopup() {
      this.errorPopup.isOpened = false
    },
    signOut() {
      this.$store.dispatch('auth/authLogout')
    },
    async trySignIn() {
      this.canSignIn = false
      const password = this.password.trim()
      const res = await this.mixinHandleSignIn(this.email, password)
      if (res === true) {
        this.$router.push({ path: '/main' })
      } else {
        if (res === 'not authorized') {
          this.errorPopup.message = '有効時間が過ぎています。'
        } else if (res === 'account suspension') {
          this.errorPopup.message = `アカウントの期限が過ぎています。\n再度アカウントを利用したい場合、担当者にご連絡ください。`
        } else if (res === 'login limit over') {
          this.errorPopup.message = `契約プランの同時ログイン数の上限を超えている可能性があります。\nログインの数を確認したうえで再度お試しください。`
        } else {
          this.errorPopup.message =
            'メールアドレスもしくはパスワードが無効です。'
        }
        this.errorPopup.isOpened = true
        this.canSignIn = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  > .login-text {
    margin: 55px 0 30px;
    font-size: 15px;
    font-weight: bold;
  }
  > .text-input-password {
    margin: 30px 0 20px;
  }
  > .login-button {
    margin: 30px 0 20px;
  }
  > .forget-password {
    font-size: 13px;
    color: #{$pumpkin};
  }
}
</style>
